import { startPage } from '../main';

// Pages with no behaviour of their own: the header, footer and sign-in dialogs.
startPage();
